export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const FB_APP_ID = process.env.REACT_APP_FB_APP_ID;

export const TABLE_MAP = {
  1: "Music video của năm",
  2: "Bài hát của năm",
  3: "Nữ ca sĩ của năm",
  4: "Nam ca sĩ của năm",
  5: "Nghệ sĩ mới của năm",
  6: "Gương mặt của năm",
  7: "Gương mặt trẻ của năm",
};

export const TABLE_CODE_MAP = {
  1: "a",
  2: "b",
  3: "c",
  4: "d",
  5: "e",
  6: "f",
  7: "g",
};
